import { PaymentMethod } from '@restaurant/types';

export const PAYMENT_METHOD_TEXT = {
  [PaymentMethod.Cash]: 'Cash',
  [PaymentMethod.EDC]: 'EDC',
  [PaymentMethod.Transfer]: 'Transfer',
  [PaymentMethod.Wallet]: 'Wallet',
  [PaymentMethod.Other]: 'Lainnya',
  [PaymentMethod.Split]: 'Split',
};

export const PAYMENT_METHOD_OPTIONS = [
  PaymentMethod.Cash,
  PaymentMethod.EDC,
  PaymentMethod.Transfer,
  PaymentMethod.Wallet,
  PaymentMethod.Other,
  PaymentMethod.Split,
].map((value) => ({
  value,
  label: PAYMENT_METHOD_TEXT[value],
}));
